$(document).ready(function() {
    var ajaxPath = '/action/tag';
    var ajaxPathForm = '/action/tag/form';
    var ajaxPathListItems = '/action/tag/list-items';

    var formWrapperId = 'tag_form_wrapper';
    var formWrapper = $('div#' + formWrapperId);

    var listWrapperId = 'tag_list_wrapper';
    var listWrapper = $('div#' + listWrapperId);

    var alertWrapperId = 'tag_alert_wrapper';
    var alertWrapperSelector = 'div#' + alertWrapperId;
    var tagText = $(alertWrapperSelector).data();

    var ajaxLockActive = false;
    var currentTagId = 0;


    // Get edit form for tag
    $(document).on('click', 'div#' + listWrapperId + ' a.tag_list_item', function () {
        currentTagId = $(this).attr('tag_id') * 1;
        setActiveListItem('div#' + listWrapperId + ' a.tag_list_item', currentTagId, 'tag_id');
        refreshForm(currentTagId);
        return false;
    });

    let globalColor = "";

    // Save tag
    $(document).on('click', 'div#' + formWrapperId + ' button#save_tag', function () {
        if (ajaxLockActive) {
            return false;
        }

        let name = $('div#' + formWrapperId + ' input[name="name"]').val();
        if (name.length === 0) {
            displayTailwindAlert(tagText.errorTitle, tagText.nameRequired, alertWrapperSelector, 'error', 'replace', true);
            return false;
        }
        let type = $('div#' + formWrapperId + ' select[name="type"]').val();
        let tagId = 0;

        const idSelector = $('div#' + formWrapperId + ' input[name="tag_id"]');
        if (idSelector.length) {
            tagId = idSelector.val();
        }

        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: ajaxPath,
            data: {
                name: name,
                type: type,
                color: globalColor,
                tag_id: tagId,
            },
            dataType: 'json'
        }).success(function (data) {
            displayTailwindAlert(tagText.savedTitle, tagText.savedMessage.replace(':url', window.location.href), alertWrapperSelector, 'success', 'replace', true);
            refreshListItems();
        }).error(function (data) {
            var errors = $.parseJSON(data.responseText).errors;
            displayTailwindAlert(tagText.errorTitle, Array.isArray(errors) ? errors.join('<br>') : errors, alertWrapperSelector, 'error', 'replace', true);
        }).always(function() {
            ajaxLockActive = false;
        });
        return false;
    });

    /*
	 * Change status of a Tag
	 * Active = 1: active
	 * Active = 0: inactive
	 */
    $(document).on('click', 'div#' + formWrapperId + ' a.change_active_status', function () {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        const activeStatus = $(this).attr('active');

        // User must confirm deactivation
        if (activeStatus === '1') {
            if (!confirm(tagText.confirmDeactivate)) {
                return;
            }
        }

        const tagId = $('div#' + formWrapperId + ' input[name="tag_id"]').val();
        if (isNaN(tagId)) {
            displayTailwindAlert(tagText.errorTitle, tagText.statusNotFound, alertWrapperSelector, 'error', 'replace', true);
            return;
        }

        // Send opposite value
        const active = (activeStatus === '1') ? 0 : 1;

        ajaxLockActive = true;
        $.ajax({
            type: 'POST',
            url: ajaxPath,
            data: {
                active: active,
                tag_id: tagId
            },
            dataType: 'json'
        }).success(function (data) {
            displayTailwindAlert(tagText.savedTitle, tagText.savedMessage.replace(':url', window.location.href), alertWrapperSelector, 'success', 'replace', true);
            refreshListItems();
        }).error(function (data) {
            var errors = $.parseJSON(data.responseText).errors;
            displayTailwindAlert(tagText.errorTitle, Array.isArray(errors) ? errors.join('<br>') : errors, alertWrapperSelector, 'error', 'replace', true);
        }).always(function() {
            ajaxLockActive = false;
        });
        return false;
    });

    /*
	 * Display or hide filter options
	 */
    $(document).on('click', 'div#' + listWrapperId + ' span#filter_span_wrapper', function () {
        var filterOptions = $('div#filter_options_wrapper');
        var arrow = $('span#filter_span_wrapper span#filter_arrow');

        if (filterOptions.is(':visible')) {
            filterOptions.hide();
            arrow.css('transform', 'rotate(0deg)');
        } else {
            filterOptions.css('display', 'flex');
            arrow.css('transform', 'rotate(90deg)');
        }
    });

    const listWrapDiv = `div#${listWrapperId}`;
    // These have display_"norwegian name"_tags name
    const displayTagNames = [
        "display_deactivated",
        "display_vare_tags",
        "display_varegruppe_tags",
        "display_kunde_tags",
        "display_kundegruppe_tags",
        "display_forhandler_tags",
    ];
    displayTagNames.forEach(tag => {
        addListenerToElement(listWrapDiv + ` input[name="${tag}"]`, refreshListItems);
    });

    function addListenerToElement(elementContext, callback) {
        $(document).on('click', elementContext, function () {
            callback();
        });
    }

    /*
	 * Search if search button was clicked
	 */
    $('div#' + listWrapperId + ' button#tag_search_button').click(function(){
        refreshListItems();
    });

    /*
	 * Search if enter key in the search field
	 */
    $('div#' + listWrapperId + ' input#tag_search_input').keyup(function(e) {
        var key = e.which;
        var searchInput = $('input#tag_search_input');

        // Refresh list if enter was pressed or the search field is empty
        if (key === 13 || searchInput.val() === '') {
            refreshListItems();
        }
    });

    function refreshForm(tagId) {
        var ajaxPath = ajaxPathForm;
        if (!isNaN(tagId) && tagId > 0) {
            ajaxPath = ajaxPathForm + '/' + tagId
        }
        $.ajax({
            type: 'GET',
            url: ajaxPath,
            data: {
            },
            dataType: 'json'
        }).success(function (data) {
            formWrapper.html(data.html);
            initColorPicker();
        }).error(function (data) {
            displayTailwindAlert(tagText.errorTitle, data.errors, alertWrapperSelector, 'error', 'replace', true);
        });
        return false;
    }

    function refreshListItems() {
        const data = {}
        displayTagNames.forEach(tag => {
            data[tag] = $(`input[name="${tag}"`, listWrapper).is(':checked') ? 1 : 0;
        });
        data.search_string = $('div#' + listWrapperId + ' input#tag_search_input').val();

        $.ajax({
            type: 'GET',
            url: ajaxPathListItems,
            data,
            dataType: 'json'
        }).success(function (data) {
            $('div.list-group', listWrapper).replaceWith(data.html);
            if (currentTagId > 0) {
                setActiveListItem('div#' + listWrapperId + ' a.tag_list_item', currentTagId, 'tag_id');
            }
        }).error(function (data) {
            const errors = $.parseJSON(data.responseText).errors;
            displayTailwindAlert(tagText.errorTitle, Array.isArray(errors) ? errors.join('<br>') : errors, alertWrapperSelector, 'error', 'replace', true);
        });
        return false;
    }

    initColorPicker();
    function initColorPicker() {
        $('#tag_color_picker', formWrapper).each(function () {
            $(this).simpleColorPicker({
                showEffect: 'fade',
                hideEffect: 'slide',
                onChangeColor: function (color) {
                    globalColor = color;
                    $(this).css("background", color);
                }
            });
        });
    }
});
